// extracted by mini-css-extract-plugin
export default {"background":"Messages_background__d0wtz"};